import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Copy, Users } from 'lucide-react';
const steps = [{
  num: '01',
  icon: <BookOpen size={24} data-id="element-133" />,
  title: 'Lee',
  desc: 'Abre el PDF y dedica 15 minutos a los conceptos básicos (adiós al miedo).'
}, {
  num: '02',
  icon: <Copy size={24} data-id="element-134" />,
  title: 'Copia',
  desc: 'Usa nuestras plantillas listas para usar en ChatGPT o Perplexity.'
}, {
  num: '03',
  icon: <Users size={24} data-id="element-135" />,
  title: 'Conecta',
  desc: 'Aplica las dinámicas de juego con tus hijos/alumnos y observa cómo aprenden juntos.'
}];
export function HowItWorks() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-136">
      <div className="max-w-5xl mx-auto" data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-139">Cómo funciona</h2>
          <p className="text-lg text-brand-text" data-id="element-140">
            Un proceso simple de 3 pasos para dominar la IA hoy mismo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-141">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-cream-200 -z-0" data-id="element-142"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-143">
              <div className="w-24 h-24 bg-cream-100 rounded-full flex items-center justify-center mb-6 border-8 border-white shadow-sm relative" data-id="element-144">
                <div className="text-brand-blue" data-id="element-145">{step.icon}</div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-brand-orange text-white rounded-full flex items-center justify-center font-bold text-sm shadow-sm" data-id="element-146">
                  {step.num}
                </div>
              </div>
              <h3 className="text-xl font-bold mb-3 text-brand-dark" data-id="element-147">
                {step.title}
              </h3>
              <p className="text-brand-text leading-relaxed" data-id="element-148">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}